import { motion } from "framer-motion";
import { UserPlus, Sparkles, Handshake } from "lucide-react";

const steps = [
{
  icon: UserPlus,
  title: "Create Your Profile",
  description: "Founders showcase their startup. Investors define their thesis. It takes under 2 minutes."
},
{
  icon: Sparkles,
  title: "Discover & Swipe",
  description: "Our filtering engine surfaces relevant opportunities based on investment fit. Review, connect, or pass quickly and deliberately."
},
{
  icon: Handshake,
  title: "Close the Deal",
  description: "Mutual interest unlocks direct communication, with built-in tools to support the deal process, including integrated wallet infrastructure."
}];


const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 md:py-32">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16">

          <h2 className="text-3xl sm:text-4xl font-display font-bold mb-4">
            How <span className="text-gradient">AdV3nture</span> Works
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">Three simple steps to your next funding round, or your next portfolio company.

          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {steps.map((step, i) =>
          <motion.div
            key={step.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.15 }}
            className="glass rounded-2xl p-8 text-center group hover:border-primary/30 transition-colors">

              <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-primary/10 text-primary mb-6 group-hover:glow-primary transition-shadow">
                <step.icon className="w-7 h-7" />
              </div>
              <div className="text-sm font-medium text-primary mb-2">Step {i + 1}</div>
              <h3 className="text-xl font-display font-semibold mb-3">{step.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{step.description}</p>
            </motion.div>
          )}
        </div>
      </div>
    </section>);

};

export default HowItWorks;